import React, { useEffect } from "react";
import { Link } from "react-router-dom";
/*import blog3 from '../../images/blog-details/comments-author/img-1.jpg'*/
/*import blog4 from '../../images/blog-details/comments-author/img-2.jpg'*/
/*import blog5 from '../../images/blog-details/comments-author/img-3.jpg'*/
import blog6 from "../../images/blog-details/logopeq.png";
/*import gl1 from '../../images/blog/img-3.jpg'*/
/*import gl2 from '../../images/blog/img-2.jpg'*/
import proyects from "../../api/projects";
import { useParams } from "react-router-dom";
import ProjectClusterHorizontalList from "../ProjectClusterHorizontalList";
import ProyectSideBar from "../ProyectSideBar";

const ProyectSingle = (props) => {
  const { id = "" } = useParams(1);

  const [proyectContent, setProyectContent] = React.useState({ title: "Cargando...", texto: "Cargando...", video: "" });
  console.log("🚀 ~ BlogSingle ~ id:", id);
  const ProyectDetails = proyects.find((item) => item.id === id);
  useEffect(() => {
    if (ProyectDetails && ProyectDetails.pages && ProyectDetails.pages[props.page]) {
      setProyectContent(ProyectDetails.pages[props.page]);
      console.log("hola");
    } else {
      setProyectContent({ title: "No encontrado", texto: "No se encontró el proyecto.", video: "" });
    }
  }, [props.page, ProyectDetails]);

  const submitHandler = (e) => {
    e.preventDefault();
  };
  console.log("🚀 ~ BlogSingle ~ blogContent:", proyectContent);

  return (
    <section className="wpo-blog-single-section section-padding">
      <div className="container">
        <div className="row">
          <div className={`col col-lg-8 col-12 ${props.blRight}`}>
            <div className="wpo-blog-content">
              <div className="post format-standard-image">
                <div className="entry-media">
                  <img src={proyectContent.mainImg} alt="" />
                </div>
                <div className="entry-meta">
                  <ul>
                    <li>
                      <i className="fi flaticon-user"></i> By{" "}
                      <Link to="/blog-single/1">{ProyectDetails ? ProyectDetails.author : "-"}</Link>{" "}
                    </li>
                    <li>
                      <i className="fi flaticon-comment-white-oval-bubble"></i>{" "}
                      Comments {ProyectDetails ? ProyectDetails.comment : "-"}
                    </li>
                    <li>
                      <i className="fi flaticon-calendar"></i>{" "}
                      {ProyectDetails ? ProyectDetails.create_at : "-"}
                    </li>
                  </ul>
                </div>
                <h2>{proyectContent.title}</h2>
                {proyectContent.texto}

                {proyectContent.video}
              </div>

              <div className="tag-share clearfix">
                <div className="tag">
                  <span>Buscar: </span>
                  <ul>
                    <li>
                      <Link to="/blog-single/1">Donación</Link>
                    </li>
                    <li>
                      <Link to="/blog-single/1">Caridad</Link>
                    </li>
                    <li>
                      <Link to="/blog-single/1">Educación</Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="tag-share-s2 clearfix">
                <div className="tag">
                  <span>Búscanos:</span>
                  <ul>
                    <li>
                      <Link to="/blog-single/1">facebook</Link>
                    </li>
                    <li>
                      <Link to="/blog-single/1">twitter</Link>
                    </li>
                    <li>
                      <Link to="/blog-single/1">linkedin</Link>
                    </li>
                    <li>
                      <Link to="/blog-single/1">pinterest</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="author-box">
                <div className="author-avatar">
                  <Link to="/blog-single/1" target="_blank">
                    <img src={blog6} alt="" style={{ maxWidth: "120px" }} />
                  </Link>
                </div>
                <div className="author-content">
                  <Link to="/blog-single/1" className="author-name">
                    Author: DigniCo
                  </Link>
                  <p>
                    Nuestro objetivo es empoderar comunidades, generar
                    conciencia y liderar cambios sostenibles que promuevan la
                    justicia y la equidad.
                  </p>
                  <div className="socials">
                    <ul className="social-link">
                      <li>
                        <Link to="https://www.facebook.com/DigniColombia">
                          <i className="ti-facebook"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="https://x.com/DigniColombia">
                          <i className="ti-twitter-alt"></i>
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.instagram.com/dignicolombia">
                          <i className="ti-instagram"></i>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <ProjectClusterHorizontalList />
              {/*<div className="more-posts">
                <div className="previous-post">
                  <Link to="/blog">
                    <span className="post-control-link">Previous Post</span>
                    <span className="post-name">
                      At vero eos et accusamus et iusto odio dignissimos ducimus
                      qui blanditiis praesentium.
                    </span>
                  </Link>
                </div>
                <div className="next-post">
                  <Link to="/blog-left-sidebar">
                    <span className="post-control-link">Next Post</span>
                    <span className="post-name">
                      Dignissimos ducimus qui blanditiis praesentiu deleniti
                      atque corrupti quos dolores
                    </span>
                  </Link>
                </div>
              </div>

               <div className="comments-area">
                                <div className="comments-section">
                                    <h3 className="comments-title">Comments</h3>
                                    <ol className="comments">
                                        <li className="comment even thread-even depth-1" id="comment-1">
                                            <div id="div-comment-1">
                                                <div className="comment-theme">
                                                    <div className="comment-image"><img src={blog3} alt="" /></div>
                                                </div>
                                                 <div className="comment-main-area">
                                                    <div className="comment-wrapper">
                                                        <div className="comments-meta">
                                                            <h4>John Abraham <span className="comments-date">January 12,2021
                                                                At 9.00am</span></h4>
                                                        </div>
                                                        <div className="comment-area">
                                                            <p>I will give you a complete account of the system, and
                                                                expound the actual teachings of the great explorer of
                                                                the truth, </p>
                                                            <div className="comments-reply">
                                                                <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <ul className="children">
                                                <li className="comment">
                                                    <div>
                                                        <div className="comment-theme">
                                                            <div className="comment-image"><img src={blog4} alt="" /></div>
                                                        </div>
                                                        <div className="comment-main-area">
                                                            <div className="comment-wrapper">
                                                                <div className="comments-meta">
                                                                    <h4>Lily Watson <span className="comments-date">January
                                                                        12,2021 At 9.00am</span></h4>
                                                                </div>
                                                                <div className="comment-area">
                                                                    <p>I will give you a complete account of the system,
                                                                        and expound the actual teachings of the great
                                                                        explorer of the truth, </p>
                                                                    <div className="comments-reply">
                                                                        <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <ul>
                                                        <li className="comment">
                                                            <div>
                                                                <div className="comment-theme">
                                                                    <div className="comment-image"><img src={blog5} alt="" /></div>
                                                                </div>
                                                                <div className="comment-main-area">
                                                                    <div className="comment-wrapper">
                                                                        <div className="comments-meta">
                                                                            <h4>John Abraham <span className="comments-date">January
                                                                                12,2021 At 9.00am</span></h4>
                                                                        </div>
                                                                        <div className="comment-area">
                                                                            <p>I will give you a complete account of the
                                                                                system, and expound the actual teachings
                                                                                of the great explorer of the truth, </p>
                                                                            <div className="comments-reply">
                                                                                <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                        </li>
                                        <li className="comment">
                                            <div>
                                                <div className="comment-theme">
                                                    <div className="comment-image"><img src={blog3} alt="" /></div>
                                                </div>
                                                <div className="comment-main-area">
                                                    <div className="comment-wrapper">
                                                        <div className="comments-meta">
                                                            <h4>John Abraham <span className="comments-date">January 12,2021
                                                                At 9.00am</span></h4>
                                                        </div>
                                                        <div className="comment-area">
                                                            <p>I will give you a complete account of the system, and
                                                                expound the actual teachings of the great explorer of
                                                                the truth, </p>
                                                            <div className="comments-reply">
                                                                <Link className="comment-reply-link" to="/blog-single/1"><span>Reply</span></Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ol>
                                </div>
                                <div className="comment-respond">
                                    <h3 className="comment-reply-title">Post Comments</h3>
                                    <form onSubmit={submitHandler} id="commentform" className="comment-form">
                                        <div className="form-textarea">
                                            <textarea id="comment" placeholder="Write Your Comments..."></textarea>
                                        </div>
                                        <div className="form-inputs">
                                            <input placeholder="Website" type="url" />
                                            <input placeholder="Name" type="text" />
                                            <input placeholder="Email" type="email" />
                                        </div>
                                        <div className="form-submit">
                                            <input id="submit" value="Post Comment" type="submit" />
                                        </div>
                                    </form>
                                </div>
                            </div>*/}
            </div>
          </div>
          <ProyectSideBar blLeft={props.blLeft} title={proyectContent.title} audio={proyectContent.audio} imgCover={proyectContent.mainImg} pdf={ProyectDetails.pdf} />
        </div>
      </div>
    </section>
  );
};

export default ProyectSingle;
